import { Link } from "react-router-dom";
import Ico from "../components/Icons";
import useReveal from "../hooks/useReveal";
import SERVICES from "../data/services";

const METHODE = [
  { n:"01", t:"Brief & devis",     d:"On échange sur vos besoins, vos contraintes budgétaires et vos délais. Vous recevez un devis clair, détaillé et sans frais cachés sous 48h." },
  { n:"02", t:"Conception",        d:"Maquettes, arborescence, choix techniques : on valide chaque étape avec vous avant de passer au développement." },
  { n:"03", t:"Développement",     d:"Nos équipes construisent votre solution avec des points d'avancement réguliers, pour que vous suiviez le projet en toute transparence." },
  { n:"04", t:"Livraison & formation", d:"Mise en ligne, formation de votre équipe à l'outil, et période de garantie pour ajuster les derniers détails." },
];

const FAQ = [
  { q:"Combien de temps faut-il pour créer un site web ?", a:"En moyenne, un site vitrine est livré en 7 à 15 jours et un site e-commerce en 3 à 4 semaines, selon la complexité et la rapidité des retours de votre côté. Le Pack Business Pro suit un calendrier optimisé pour une mise en ligne en 48h à 72h sur les éléments essentiels." },
  { q:"Proposez-vous un accompagnement après la livraison ?", a:"Oui, tous nos projets incluent une période de garantie et un accompagnement de suivi (le Pack Business Pro inclut 3 mois de formation et de suivi). Des contrats de maintenance mensuelle sont également disponibles pour un support continu." },
  { q:"Travaillez-vous avec tous les types de commerces ?", a:"Nous accompagnons aussi bien des commerces de quartier que des restaurants, cabinets de conseil, boutiques en ligne ou PME multi-sites. Chaque solution est adaptée à votre secteur et à votre budget." },
  { q:"Le premier échange est-il vraiment gratuit ?", a:"Oui. Le premier rendez-vous sert à comprendre votre besoin et à vous donner des recommandations concrètes, même si vous décidez de ne pas travailler avec nous ensuite." },
  { q:"Puis-je commencer par un seul service et évoluer plus tard ?", a:"Bien sûr. Beaucoup de nos clients démarrent avec un site web ou une fiche Google Business, puis ajoutent un logiciel de gestion ou une stratégie marketing une fois les premiers résultats visibles." },
];

export default function Services() {
  useReveal();

  return (
    <div className="pagewrap">
      <section className="sec" style={{ background: "var(--w)" }}>
        <div className="secinr">
          <div className="sechdr r">
            <div className="lbl"><span className="lblline" />Ce que nous faisons</div>
            <h2 className="sh2">Nos <em>services</em></h2>
            <p className="slead">De la maintenance informatique à la stratégie digitale complète, en passant par le développement web et le marketing : un seul partenaire pour tous vos besoins numériques, quel que soit votre point de départ.</p>
          </div>
          <div className="srvgrid">
            {SERVICES.map((s, i) => (
              <div className="srvc r" key={s.slug} style={{ transitionDelay: `${i * .045}s` }}>
                <div className="srviw"><Ico name={s.ico} size={21} /></div>
                <div className="srvn">{s.name}</div>
                <p className="srvd">{s.tagline}</p>
                <div className="srvfeats">
                  {s.features.slice(0, 3).map(f => (
                    <div className="srvfeat" key={f}><Ico name="check" size={13} color="var(--blue-m)" />{f}</div>
                  ))}
                </div>
                <Link className="srvlnk" style={{ opacity: 1, transform: "none" }} to={s.isPackRedirect ? "/packs" : `/services/${s.slug}`}>
                  En savoir plus <Ico name="arrowR" size={12} />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* MÉTHODE PROJET */}
      <section className="sec" style={{ background: "var(--off)" }}>
        <div className="secinr">
          <div className="sechdr r">
            <div className="lbl"><span className="lblline" />Déroulé d'un projet</div>
            <h2 className="sh2">Notre <em>méthode</em></h2>
            <p className="slead">Du premier brief à la livraison, chaque projet suit un cadre clair pour éviter les mauvaises surprises et respecter vos délais.</p>
          </div>
          <div className="stepgrid">
            {METHODE.map((s, i) => (
              <div className="stepc r" key={s.n} style={{ transitionDelay: `${i * .08}s` }}>
                <div className="stepnum">{s.n}</div>
                <div className="stept">{s.t}</div>
                <p className="stepd">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PACK */}
      <section className="sec" style={{ background: "var(--w)" }}>
        <div className="secinr">
          <div className="packwrap r">
            <div className="packinr">
              <div>
                <div className="packlbl"><span className="lblline" style={{ background: "linear-gradient(90deg,var(--cyan),#93c5fd)" }} />Notre vision</div>
                <h2 className="packh">Nous ne réparons pas que des ordinateurs.<br />Nous faisons <em>gagner plus.</em></h2>
                <p className="packsub">Le Pack Business Pro combine site web, présence Google, logiciel de gestion et stratégie marketing en une seule offre cohérente — pensée pour les PME ambitieuses qui veulent avancer vite sans multiplier les prestataires.</p>
                <div className="packfeats">
                  {["Site web professionnel inclus", "Fiche Google Business optimisée", "Logiciel de gestion sur-mesure", "Formation & suivi 3 mois"].map(f => (
                    <div className="packfeat" key={f}><Ico name="check" size={14} color="var(--cyan)" />{f}</div>
                  ))}
                </div>
                <Link className="packbtn" to="/packs">Découvrir nos Packs <Ico name="arrowR" size={15} color="var(--navy)" /></Link>
              </div>
              <div className="packstats">
                {[["50+", "clients", "accompagnés"], ["×3", "croissance", "moyenne"], ["48h", "délai", "de mise en ligne"]].map(([v, l, s]) => (
                  <div className="packstat" key={l}>
                    <div className="psval">{v}</div>
                    <div className="pslabel">{l.charAt(0).toUpperCase() + l.slice(1)} — {s}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="sec" style={{ background: "var(--off)" }}>
        <div className="secinr">
          <div className="sechdr r">
            <div className="lbl"><span className="lblline" />Questions fréquentes</div>
            <h2 className="sh2">Vous vous <em>demandez peut-être...</em></h2>
            <p className="slead">Les réponses aux questions qu'on nous pose le plus souvent avant de démarrer un projet.</p>
          </div>
          <div className="faqlist r" style={{ transitionDelay: ".1s" }}>
            {FAQ.map(f => (
              <details className="faqitem" key={f.q}>
                <summary>{f.q}<span className="faqicon"><Ico name="arrowR" size={13} /></span></summary>
                <p className="faqa">{f.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}